import { Injectable, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DynamicFieldsManagerService } from '../dynamic-fields/dynamic-fields-manager.service';
import { DynamicLoadingUtil } from 'src/app/shared/helpers/dynamic-loading-util';
import { RouteNavigationService } from '../dynamic-routes-loader/route-navigation.service';
import { BehaviorSubject } from 'rxjs';
import { ResponseStatus, DialogType } from 'src/app/shared/components/sem-dynamic/sem-dynamic.component';
import { Url } from 'src/app/models/navigation/navigation-node-model';
import { type } from 'os';
import { SemConfirmDialogComponent } from 'src/app/components/controls/dialogs/sem-confirm-dialog/sem-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SearchService } from '../search/search.service';
import { LocalStorageService } from '../local-storage-service/local-storage.service';
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';
import { QueryList } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';

/**
 * Provides various JavaScript utility services that can be used on WG client-side
 */
@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  // property for sending selected values between 2 dropdowns
  private dropdownSelectedValue = new BehaviorSubject<any>(undefined);
  currentDropdownSelectedValue = this.dropdownSelectedValue.asObservable();

  public newSectionAdded = new BehaviorSubject<any>(undefined);
  newSectionAddedObsr = this.newSectionAdded.asObservable();

  public reqResponse: boolean = false;
  public reqStatus: ResponseStatus;
  public reqMessage: string;
  public preFormSubmitJS: string = null;
  public openPopupBeforeSaveMessage: string = null;
  public openPopupBeforeSaveCondition: string = null;
  public openPopupBeforeSave: boolean = false;
  public redirectUrlAfterSubmit: string = null;
  public tabInformations: any = null;
  public afterFormSubmitErrorJS: string = null;
  public afterFilesSaveFormAction:string = null;
  public afterSavePopupCondition:string = null;

  public afterFilesSavedParameterModel:any = null;

  public afterSaveApiUrl: string = null;
  public afterSaveApiData: any = null;

  public afterSavePopup: boolean = false;
  public afterSavePopupText: string = "";

  public stateObjectHistory: StateHistory[] = [];

  // listener for expanding/colapsin facets
  private facetsCollapsed = new BehaviorSubject(undefined);
  currentFacetsCollapsed = this.facetsCollapsed.asObservable();

  constructor(public injector: Injector, public router: Router, public activatedRoute: ActivatedRoute, public dfms: DynamicFieldsManagerService, public dialog: MatDialog, public searchService: SearchService, public localStorageService: LocalStorageService, public location:Location) {
  }

  public get dynamicRoutesLoader(): RouteNavigationService { //this creates router property on your service.
    return this.injector.get(RouteNavigationService);
  }

  newDropdownValueSelected(value, selectedDropdownBinding) {
    this.dropdownSelectedValue.next({
      "SelectedValue": value,
      "SelectedDropDownBinding": selectedDropdownBinding
    });
  }

  async processNavigationUrl(url, stateModel = null, passthroughPopup = false, ignoreHistorySearchState = false) {

    //Hack for AZ... it's friday 4 o'clock man....
    //passthroughPopup = true;

    if (this.router.url.includes("list?model=")) {
      this.searchService.historySearchState = {};

      if(ignoreHistorySearchState === false){
        this.searchService.historySearchState["query"] = this.searchService.searchState;
        this.searchService.historySearchState["url"] = window.location.href;
        this.searchService.historySearchState["additionalFields"] = this.searchService.historySearchStateAdditionalFields;
        this.searchService.historySearchState["mainSearchValue"] = this.searchService.historySearchMainSearchFieldValue;
      }      
    }

    if (passthroughPopup) {
      await this.processNavigate(url, stateModel);
    } else if (environment.navigateAwayPopupEnabled) {

      if (typeof url != "undefined" && url != "") {
        if (!this.router.url.includes("/list?") && !this.router.url.includes("dashboard") && !this.router.url.includes("/galisweb/search")) {

          DynamicLoadingUtil.loader.showLoader = false;

          if (this.dfms.wasInEditMode) {
            const dialogRef = this.dialog.open(SemConfirmDialogComponent, { width: '350px', height: '185px', data: { type: DialogType.Confirmation, text: 'WebGalis_NavigateAway' } });
            dialogRef.afterClosed().subscribe(async result => {

              if (result) {
                await this.processNavigate(url, stateModel);
              }

            });
          } else {
            await this.processNavigate(url, stateModel);
          }
        } else {

          await this.processNavigate(url, stateModel);

        }
      }
    }
  }

  updateURLQueryParam(url: string, param: string, newValue: string, baseUrl: string = ''): string {
    // If the URL is partial, prepend the base URL
    const fullUrl = baseUrl ? `${baseUrl}${url}` : url;

    // Parse the URL
    let urlObj = new URL(fullUrl, window.location.origin); // Use window.location.origin as a fallback for relative URLs

    // Modify the specific query parameter
    urlObj.searchParams.set(param, newValue);

    // Return the updated URL as a string
    return urlObj.pathname + urlObj.search + urlObj.hash; // Return the partial URL if base URL was used
  }

  async processNavigate(url, stateModel = null) {
    this.reqResponse = false;

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    if (typeof DynamicLoadingUtil.loader != "undefined") {
      DynamicLoadingUtil.loader.showLoader = true;
    }

    this.router.onSameUrlNavigation = "reload";
    var compExists = false;

    var urlToGenerate = "";
    if (url.includes("?")) {
      urlToGenerate = url.split("?")[0];
    } else {
      urlToGenerate = url;
    }

    for (var i = 0; i < this.router.config.length; i++) {
      if (this.router.config[i]["path"] == urlToGenerate) {
        compExists = true;
        break;
      }
    }

    if (!compExists) {
      await this.dynamicRoutesLoader.loadConfig(urlToGenerate);
    }

    if (stateModel == null) {

      let currentNav = this.router.getCurrentNavigation();
      if (currentNav) {
        currentNav.extras.state = {}; // Resetting the state
      }

      // Fix: use replaceUrl only for same-URL navigation (e.g. reload after save)
      // to avoid duplicate history entries. For cross-page navigation, let the
      // router push a new history entry so browser Back works correctly.
      const isSameUrl = this.router.url === '/' + url || this.router.url === url;
      this.router.navigateByUrl(url, { state: null, replaceUrl: isSameUrl });
    } else {

      this.router.navigateByUrl(url, { state: stateModel });
    }

    if (typeof DynamicLoadingUtil.loader != "undefined") {
      DynamicLoadingUtil.loader.showLoader = false;
    }
  }

  getStateFromHistory(url: string): StateHistory {
    for (var i = 0; i < this.stateObjectHistory.length; i++) {
      if (this.stateObjectHistory[i].Url == url) {
        if (!this.stateObjectHistory[i].StateObject["type"]) {
          return this.stateObjectHistory[i];
        } else {
          return null;
        }
        break;
      }
    }

    return null;
  }

  modifyStateFromHistory(state: StateHistory): StateHistory {

    let updated: Boolean = false;

    if (typeof state != "undefined" && state) {
      for (var i = 0; i < this.stateObjectHistory.length; i++) {
        if (this.stateObjectHistory[i].Url == state.Url) {
          this.stateObjectHistory[i] = state;
          updated = true;
          break;
        }
      }
    }

    if (!updated) {
      this.stateObjectHistory.push(state);
    }

    return state;
  }

  checkStateForValidity(url: string, stateModel: any): any {
    if ((typeof stateModel == "undefined" || stateModel == null) || (Object.keys(stateModel).length == 1 && Object.keys(stateModel)[0] == "navigationId")) {
      var sm = this.getStateFromHistory(url);

      if (sm != null) {
        stateModel = sm.StateObject;
      }
    } else {
      let stModel = { Url: url, StateObject: stateModel };
      this.modifyStateFromHistory(stModel)
    }

    return stateModel;
  }

  setFacetsCollapsed(value) {
    this.facetsCollapsed.next(value);
  }

  isFormExpicitEditMode() {

    var route = this.getCurrentRoute();

    if (route) {
      return route.ExplicitEditMode;
    } else {
      return false
    }

  }

  getCurrentRoute() {
    let loadedRoutes = this.localStorageService.get("api/navigation/getRoutes");

    if (loadedRoutes != null) {
      let loadedRoutesArr: any[] = JSON.parse(loadedRoutes);

      for (var i = 0; i < loadedRoutesArr.length; i++) {
        var urlToCompare = loadedRoutesArr[i]["PrettyUrl"];

        let url = window.location.pathname;
        if (url.startsWith("/")) {
          url = url.substring(1);
        }

        //if (urlToCompare == url && loadedRoutesArr[i].ExplicitEditMode) {
        if (urlToCompare == url) {
          return loadedRoutesArr[i];
        }
      }
    }

    return null;
  }


  // #region dynamic form access
  // The SemDynamicComponent(s) currently rendered. Registered by SemDynamicComponent so that
  // client-side JS (button OnValueChangeEval, custom action PreJS/PostJS, navigation node
  // ActionBody, ...) can reach the form no matter which component is the eval context, e.g.:
  //    this.utility.formSubmit();
  //    this.utility.getForm().model
  // a stack, so a dynamic form opened in a popup takes over while it is open
  // and the underlying page becomes active again once the popup is closed
  private formsStack: SemDynamicFormHost[] = [];

  registerForm(p_form: SemDynamicFormHost) {
    if (p_form == null) {
      return;
    }

    this.unregisterForm(p_form);
    this.formsStack.push(p_form);
  }

  unregisterForm(p_form: SemDynamicFormHost) {
    let index = this.formsStack.indexOf(p_form);

    if (index > -1) {
      this.formsStack.splice(index, 1);
    }
  }

  /**
   * Returns the currently active dynamic form (the popup one when a form popup is open),
   * null when no dynamic form is rendered.
   *
   * SemDynamicComponent is also the base class of the master page / navigation components,
   * which register themselves as well but render no <form #f>. So we look for the topmost
   * entry that actually has a form and only fall back to the topmost entry when there is none.
   */
  getForm(): SemDynamicFormHost {
    for (var i = this.formsStack.length - 1; i >= 0; i--) {
      if (this.formsStack[i].mainForm != null) {
        return this.formsStack[i];
      }
    }

    if (this.formsStack.length == 0) {
      return null;
    }

    return this.formsStack[this.formsStack.length - 1];
  }

  /**
   * Model of the currently active dynamic form, null when there is no form
   */
  getFormModel(): any {
    let form = this.getForm();

    return form == null ? null : form.model;
  }

  /**
   * Submits the currently active dynamic form, exactly as if the user clicked the save button
   * (validation, popup before save, file uploads and after save logic all still run).
   * Returns false when there is no dynamic form to submit.
   */
  formSubmit(): boolean {
    let form = this.getForm();

    if (form == null || typeof form.formSubmit != "function") {
      return false;
    }

    form.formSubmit();

    return true;
  }
  // #endregion

  // #region mat-tab navigation
  // Tab groups of the currently rendered dynamic page (SemFormTabsControl renders <mat-tab-group>).
  // Registered by SemDynamicComponent so that client-side JS (button OnValueChangeEval,
  // custom action PreJS/PostJS, navigation node ActionBody, ...) can switch tabs, e.g.:
  //    this.utility.nextTab();
  //    this.utility.goToTab(2);
  //    this.utility.goToTabByLabel('Documents');
  // stack, so a dynamic form opened in a popup takes over while it is open
  // and the underlying page becomes active again once the popup is closed
  private tabGroupsStack: QueryList<MatTabGroup>[] = [];

  registerTabGroups(p_tabGroups: QueryList<MatTabGroup>) {
    if (p_tabGroups == null) {
      return;
    }

    this.unregisterTabGroups(p_tabGroups);
    this.tabGroupsStack.push(p_tabGroups);
  }

  unregisterTabGroups(p_tabGroups: QueryList<MatTabGroup>) {
    let index = this.tabGroupsStack.indexOf(p_tabGroups);

    if (index > -1) {
      this.tabGroupsStack.splice(index, 1);
    }
  }

  /**
   * Returns the mat-tab-group of the current form. groupIndex 0 is the main (outer) tab control,
   * higher indexes are nested/sub tab controls in the order they appear in the template.
   */
  getTabGroup(groupIndex: number = 0): MatTabGroup {
    let tabGroups = this.tabGroupsStack[this.tabGroupsStack.length - 1];

    if (tabGroups == null || tabGroups.length == 0) {
      return null;
    }

    return tabGroups.toArray()[groupIndex];
  }

  /**
   * Index of the currently selected tab, -1 when there is no tab control on the form
   */
  getSelectedTabIndex(groupIndex: number = 0): number {
    let group = this.getTabGroup(groupIndex);

    if (group == null || group.selectedIndex == null) {
      return -1;
    }

    return group.selectedIndex;
  }

  /**
   * Switches to the tab on given index, exactly as if the user clicked on its header
   * (so tabs bound to a FormUrl still navigate - that logic lives on the mat-tab-group click handler).
   */
  goToTab(index: number, groupIndex: number = 0): boolean {
    let group = this.getTabGroup(groupIndex);

    if (group == null || index == null || index < 0 || index >= group._tabs.length) {
      return false;
    }

    if (group._tabs.toArray()[index].disabled) {
      return false;
    }

    // the group's own header is always the first <mat-tab-header> inside the host,
    // nested tab groups live in the tab bodies that come after it
    let headerElement = group._elementRef.nativeElement.querySelector('mat-tab-header');
    let header = headerElement ? headerElement.querySelectorAll('.mat-mdc-tab')[index] : null;

    if (header) {
      header.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    } else {
      // fallback when the header element is not in the DOM (e.g. hidden tab)
      group.selectedIndex = index;
    }

    return true;
  }

  /**
   * Switches to the first tab whose label matches (case insensitive, trimmed)
   */
  goToTabByLabel(label: string, groupIndex: number = 0): boolean {
    let group = this.getTabGroup(groupIndex);

    if (group == null || label == null) {
      return false;
    }

    let tabs = group._tabs.toArray();
    let searched = label.trim().toLowerCase();

    for (var i = 0; i < tabs.length; i++) {
      let tabLabel = tabs[i].textLabel;

      if (tabLabel != null && tabLabel.trim().toLowerCase() == searched) {
        return this.goToTab(i, groupIndex);
      }
    }

    return false;
  }

  /**
   * Switches to the next selectable tab, skipping disabled ones (non clickable "parent" tabs).
   * Wraps around to the first tab when the last one is selected.
   */
  nextTab(groupIndex: number = 0): boolean {
    return this.moveTab(1, groupIndex);
  }

  /**
   * Switches to the previous selectable tab, skipping disabled ones. Wraps around to the last tab.
   */
  previousTab(groupIndex: number = 0): boolean {
    return this.moveTab(-1, groupIndex);
  }

  private moveTab(step: number, groupIndex: number): boolean {
    let group = this.getTabGroup(groupIndex);

    if (group == null) {
      return false;
    }

    let tabs = group._tabs.toArray();

    if (tabs.length == 0) {
      return false;
    }

    let selected = group.selectedIndex == null ? 0 : group.selectedIndex;

    // walk the whole ring once, so we also wrap around
    for (var i = 1; i <= tabs.length; i++) {
      let index = (selected + (step * i) + (tabs.length * i)) % tabs.length;

      if (!tabs[index].disabled) {
        return this.goToTab(index, groupIndex);
      }
    }

    return false;
  }
  // #endregion

}

export interface StateHistory {
  Url: string;
  StateObject: any;
}

/**
 * Minimal contract of SemDynamicComponent used by UtilityService - declared here instead of
 * importing the component so the client-side JS helpers stay free of a hard component dependency.
 */
export interface SemDynamicFormHost {
  model: any;
  mainForm: any;
  formSubmit(): void;
}
